import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { gql } from '@apollo/client';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { LikeOutput, LikeTargetType, UnlikeOutput } from './codecs';
export var useLike = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation Like($input: LikeInput!) {\n      like(input: $input) {\n        ... on LikeErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n\n        ... on LikeResult {\n          result {\n            id\n            createdAt\n            member {\n              id\n              name\n              title\n              avatarUrl\n            }\n          }\n        }\n      }\n    }\n  "]))), LikeOutput, t.type({
  input: t.type({
    targetID: t.string,
    targetType: LikeTargetType
  })
}));
export var useUnlike = makeDecodedMutation(gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation Unlike($input: UnlikeInput!) {\n      unlike(input: $input) {\n        ... on UnlikeErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n\n        ... on UnlikeResult {\n          result\n        }\n      }\n    }\n  "]))), UnlikeOutput, t.type({
  input: t.type({
    id: t.string
  })
}));